import { capitalizeString } from 'helpers';
import { OLD_YOUTH_SEGMENT_SHORT_NAME } from 'constants/event';

export const competitionLevel = {
  OPEN: 'open',
  YOUTH: 'youth',
  CHALLENGER: 'challenger',
  PRO: 'pro',
  DYJR: {
    value: 'dyjr',
    label: 'Junior',
  },
  DYYTH: {
    value: 'dyyth',
    label: 'Youth',
  },
  LIMITED: 'limited',
  ALL: {
    name: 'all',
    value: 'all',
  },
};

export const competitionLevels = [
  {
    value: competitionLevel.OPEN,
    label: capitalizeString(competitionLevel.OPEN),
  },
  {
    value: competitionLevel.YOUTH,
    label: capitalizeString(competitionLevel.YOUTH),
  },
  {
    value: competitionLevel.DYYTH.value,
    label: capitalizeString(competitionLevel.DYYTH.label),
  },
  {
    value: competitionLevel.DYJR.value,
    label: capitalizeString(competitionLevel.DYJR.label),
  },
  {
    value: competitionLevel.CHALLENGER,
    label: capitalizeString(competitionLevel.CHALLENGER),
  },
  {
    value: competitionLevel.PRO,
    label: capitalizeString(competitionLevel.PRO),
  },
  {
    value: competitionLevel.LIMITED,
    label: capitalizeString(competitionLevel.LIMITED),
  },
];

export const getYouthSegmentCompetitionLevels = (segment) => {
  if (segment.ShortName === OLD_YOUTH_SEGMENT_SHORT_NAME)
    return [competitionLevels[1]];
  // Old DY26, DY25... segments
  if (segment.ShortName.includes('DY'))
    return [competitionLevels[2], competitionLevels[3]];

  // new wcjr specific 15/19 segments
  return [
    { value: competitionLevel.ALL.value, label: competitionLevel.ALL.name },
  ];
};
